import { useBackgroundLocation } from "../home/components/UseBackgroundLocation";
import type { Location, ModalLocation } from "./AppRoutes";

export const useLinkModalProps = <
  TState extends {},
  TStateWithBackground = TState & { background?: Location },
>(
  modalLocation: ModalLocation,
  state?: TState,
): { to: Location; state: TStateWithBackground } => {
  const backgroundLocation = useBackgroundLocation();

  return {
    state: { ...state, background: backgroundLocation } as TStateWithBackground,
    to: modalLocation.path,
  };
};
